import Article from "./article";
import Center from "../../components/center";
import namedRoutes from "../../settings/routes";
import { lookupByUrl } from "../../settings/route-data-lookup";

const headerInfo = lookupByUrl(
  namedRoutes.article("2012/10/29", "the-blogging-begins")
);

const ArticleContent = () => (
  <Article headerInfo={headerInfo}>
    <Center>
      <h1>{headerInfo.title}</h1>
      <p>
        I will soon begin blogging occasionally. Many of the topics will be
        focused on the work I do on{" "}
        <a href="https://www.microsoft.com">Microsoft.com</a> with its homepage
        and underlying CMS.
      </p>
    </Center>
  </Article>
);

export default ArticleContent;
